export enum MessageType {
  NoMessage = 0,
  Information = 1,
  Warning = 2,
  Error = 3,
}
